import { render, staticRenderFns } from "./DiscountCodesList.vue?vue&type=template&id=880e78d8"
import script from "./DiscountCodesList.vue?vue&type=script&lang=js"
export * from "./DiscountCodesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports